<script lang="ts">
	import dayjs from 'dayjs';

	interface Props {
		currency: string;
		dividendPayoutHistory: DividendPayoutYear[];
	}

	let { currency, dividendPayoutHistory }: Props = $props();
</script>

<figure>
	<table class="border-gray-faint w-full border-1">
		<colgroup>
			<col />
			<col />
			<col class="w-28" />
		</colgroup>
		<thead class="card-bold text-left font-normal">
			<tr>
				<th>Ex-date</th>
				<th>Payment date</th>
				<th class="text-right">Amount</th>
			</tr>
		</thead>
		<tbody>
			{#each dividendPayoutHistory as dividendPayoutYear}
				<tr class="card-bold bg-gray-dark text-white-pure">
					<td colspan="1">{dividendPayoutYear.year}</td>
					<td colspan="2" class="text-right"
						>Total: {dividendPayoutYear.total.toLocaleString('default', {
							style: 'currency',
							currency,
							currencyDisplay: 'narrowSymbol',
							minimumFractionDigits: 2,
							maximumFractionDigits: 6
						})}</td
					>
				</tr>
				{#each dividendPayoutYear.dividends as dividend}
					<tr class="card-regular">
						<td>{dayjs(dividend.exDate).format('DD/MM/YY')}</td>
						<td>{dayjs(dividend.paymentDate).format('DD/MM/YY')}</td>
						<td class="text-right">
							<a
								href={dividend.link}
								class="hyperlink"
								target="_blank"
								rel="noreferrer noopener nofollow"
							>
								{dividend.declaredRate.toLocaleString('default', {
									style: 'currency',
									currency,
									currencyDisplay: 'narrowSymbol',
									minimumFractionDigits: 2,
									maximumFractionDigits: 6
								})}
							</a>
						</td>
					</tr>
				{/each}
			{/each}
		</tbody>
	</table>
</figure>

<style lang="postcss">
	@reference '../../../../app.css';

	tr {
		@apply border-gray-faint border-b-1;
		th,
		td {
			@apply p-3 lg:px-4;
		}
	}
</style>
